<template ref="addImage">
  <div class="zujian">
    <!-- 所属分类 -->
    <div class="belong-wrap">
      <span class="">所属分类：</span>
      <Select v-model="cateId"
              style="width:200px">
        <Option v-for="item in cateList"
                :value="item.cate_id"
                :key="item.cate_id">{{ item.content }}</Option>
      </Select>
    </div>
    <!-- 图片 -->
    <div class="">
      <span class="">封面图：</span>
      <upload-thumb v-model="thumbUrl"
                    ref="uploadthumb"
                    :defaultList="thumblist"
                    :autoCropWidth="670"
                    :autoCropHeight="385"
                    :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*385,大小不超过2M'"
                    :maxNum="1"></upload-thumb>
    </div>
    <div class="">
      <span class="">链接类型：</span>
      <Select v-model="link_type"
              style="width:200px">
        <Option value="1">H5</Option>
        <Option value="2">定制</Option>
        <Option value="3">盲盒</Option>
        <Option value="4">商城</Option>
        <Option value="5">非遗地图</Option>
      </Select>
    </div>
    <div class=""
         style="margin-top:10px;">
      <span class="">链接地址：</span>
      <Input v-model="linkUrl"
             placeholder="请输入..."
             style="width: 300px" />
    </div>
    <div class="drawer-footer">
      <Button style="margin-right: 8px"
              @click="cancleFun">取消</Button>
      <Button type="primary"
              @click="activityAdd">确定</Button>
    </div>
  </div>

</template>
<script>
import UploadThumb from "../../common/thumb";
export default {
  name: "",
  data () {
    return {
      thumbUrl: "",
      thumblist: [],
      linkUrl: "", // 链接
      block_content_id: null, // 模块内容id
      link_type: null, // 链接类型
      cateId: -1,
      cateList: [],
      zhuanti_id: null // 专题id
    }
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  components: {
    UploadThumb
  },
  created: function () {

  },
  methods: {
    // 初始化
    initFun (status, zhuanti_id, block_content_id) {
      this.thumbUrl = "";
      this.thumblist = [];
      this.linkUrl = "";
      this.cateId = null;
      this.block_content_id = block_content_id;
      this.zhuanti_id = zhuanti_id;
      this.getCateList(zhuanti_id);
      if (status == 1) {
        this.detailFun(block_content_id);
      }
    },
    // 分类列表
    getCateList (zhuanti_id) {
      this.$api.zhuanti.catelist({ zhuanti_id: zhuanti_id }).then(res => {
        if (res.code == 200) {
          let list = res.result; // 二维数组(可能有多个大分类)
          let arr = [];
          arr.push({
            cate_id: -1,
            content: "无"
          })
          if (list && list.length) {
            for (let i in list) {
              let item = list[i];
              for (let j in item) {
                if (item[j].content && item[j].content.length > 12) {
                  item[j].content = item[j].content.slice(0, 12) + '...'
                }
                arr.push(item[j]);
              }
            }
          }
          this.cateList = arr;
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    // 取消
    cancleFun () {
      this.$emit("showImg", -1);
    },
    // 确定
    activityAdd () {
      let imageList = this.$refs['uploadthumb'].uploadList;
      if (imageList.length == 0) {
        this.$Message.warning("请上传图片！");
        return;
      }
      let content = {
        thumb: imageList[0].url,
        link_type: this.link_type,
        link: this.linkUrl
      };
      if (this.block_content_id) {
        // 编辑
        let params = {
          block_content_id: this.block_content_id,
          content: JSON.stringify(content)
        };
        if (this.cateId && this.cateId != -1) {
          params.cate_id = this.cateId;
        }
        this.$api.zhuanti.blockedit(params).then(res => {
          if (res.code == 200) {
            this.$emit("updateContent");
          } else {
            this.$Message.error(res.msg)
          }
        })
      } else {
        // 新增
        // 有所属分类
        if (this.cateId && this.cateId != -1) {
          let params = {
            cate_id: this.cateId,
            type_id: 1, // 类型 1图片2视频3分类4竖排5横排
            content: JSON.stringify(content)
          };
          this.$api.zhuanti.blockcatecontent(params).then(res => {
            if (res.code == 200) {
              this.$emit("updateContent");
            } else {
              this.$Message.error(res.msg)
            }
          })
        } else {
          let params = {
            zhuanti_id: this.zhuanti_id,
            type_id: 1, // 类型 1图片2视频3分类4竖排5横排
            content: JSON.stringify(content)
          };
          this.$api.zhuanti.blockcreate(params).then(res => {
            if (res.code == 200) {
              this.$emit("updateContent");
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      }
    },
    // 详情
    detailFun (id) {
      console.log("详情", id);
      let params = {
        block_content_id: id
      };
      this.$api.zhuanti.blockdetail(params).then(res => {
        if (res.code == 200) {
          let content = JSON.parse(res.result.content);
          if (content.thumb) {
            this.thumblist = [{
              url: content.thumb,
              status: "finished"
            }]
          };
          this.linkUrl = content.link;
          this.link_type = content.link_type;
          if (res.result.parent_id) {
            this.cateId = res.result.parent_id;
          }
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style>
.zujian img {
  max-width: 100%;
  display: block;
}
.typecontent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
}
.drawer-footer {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>